// removed by extract-text-webpack-plugin
module.exports = {"banner":"banner__banner__2kBPN","link":"banner__link__2XDjI"};


//////////////////
// WEBPACK FOOTER
// ./src/banner/banner.scss
// module id = 199
// module chunks = 0